export default __webpack_public_path__ + "static/media/brickwalls.9cc5a42d.png";